import { Alert, Box, Button, Card, CardContent, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const OTP_LENGTH = 6;

const formatCountdown = (seconds) =>
  `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;

const OtpGate = ({
  title,
  organizationName,
  cooldownSeconds,
  codeRequested,
  sending,
  verifying,
  error,
  onSendCode,
  onVerify,
}) => {
  const [code, setCode] = useState("");
  const [remaining, setRemaining] = useState(cooldownSeconds || 0);

  useEffect(() => {
    setRemaining(cooldownSeconds || 0);
  }, [cooldownSeconds]);

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const timer = setInterval(() => setRemaining((current) => Math.max(0, current - 1)), 1000);
    return () => clearInterval(timer);
  }, [remaining]);

  const canSend = !sending && remaining <= 0;
  const canVerify = !verifying && code.trim().length === OTP_LENGTH;

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Box>
            <Typography variant="h5">{title || "Document upload"}</Typography>
            {organizationName && (
              <Typography variant="body2" color="text.secondary">
                Requested by {organizationName}
              </Typography>
            )}
          </Box>

          <Typography variant="body2">
            To keep your documents private, we will email you a {OTP_LENGTH} digit code before you
            can upload anything.
          </Typography>

          {error && <Alert severity="error">{error}</Alert>}

          {!codeRequested ? (
            <Button variant="contained" disabled={!canSend} onClick={onSendCode}>
              {sending ? "Sending..." : "Send me a code"}
            </Button>
          ) : (
            <Stack spacing={2}>
              <TextField
                label="Verification code"
                value={code}
                onChange={(event) => setCode(event.target.value.replace(/\D/g, "").slice(0, OTP_LENGTH))}
                inputProps={{ inputMode: "numeric", maxLength: OTP_LENGTH }}
                autoFocus
                fullWidth
              />
              <Button
                variant="contained"
                disabled={!canVerify}
                onClick={() => onVerify(code.trim())}
              >
                {verifying ? "Checking..." : "Verify and continue"}
              </Button>
              <Button size="small" disabled={!canSend} onClick={onSendCode}>
                {remaining > 0
                  ? `Resend code in ${formatCountdown(remaining)}`
                  : "Send another code"}
              </Button>
            </Stack>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default OtpGate;
